module.exports = __webpack_public_path__ + "img/1.c301b681.jpg";